export default "__VITE_ASSET__DLnYRwCm__"